import React from "react";

/**
 * AuroraLayer — Cinematic drifting gradient background
 * Apple-inspired ethereal motion with brand colors
 */

export default function AuroraLayer() {
  return (
    <div
      className="absolute inset-0 pointer-events-none overflow-hidden"
      style={{ zIndex: 0 }}
      aria-hidden="true"
    >
      <style>{`
        @keyframes aurora-drift-1 {
          0%, 100% { transform: translateX(-10%) translateY(-5%) scale(1.1); }
          33% { transform: translateX(5%) translateY(0%) scale(1.15); }
          66% { transform: translateX(-5%) translateY(5%) scale(1.1); }
        }
        @keyframes aurora-drift-2 {
          0%, 100% { transform: translateX(10%) translateY(5%) scale(1.2); }
          50% { transform: translateX(-10%) translateY(-5%) scale(1.25); }
        }
        @keyframes aurora-drift-3 {
          0%, 100% { transform: translateY(-8%) scale(1); opacity: 0.6; }
          50% { transform: translateY(8%) scale(1.05); opacity: 0.8; }
        }
        @keyframes aurora-pulse {
          0%, 100% { opacity: 0.4; }
          50% { opacity: 0.7; }
        }
        
        .aurora-layer-1 {
          animation: aurora-drift-1 20s ease-in-out infinite;
        }
        .aurora-layer-2 {
          animation: aurora-drift-2 25s ease-in-out infinite;
        }
        .aurora-layer-3 {
          animation: aurora-drift-3 15s ease-in-out infinite;
        }
        .aurora-pulse {
          animation: aurora-pulse 8s ease-in-out infinite;
        }
      `}</style>

      {/* Layer 1: Deep Purple — Primary brand color */}
      <div
        className="aurora-layer-1 absolute"
        style={{
          top: "-20%",
          left: "-20%",
          width: "140%",
          height: "140%",
          background: `
            radial-gradient(
              ellipse 80% 60% at 30% 40%,
              rgba(102, 54, 157, 0.18) 0%,
              rgba(90, 30, 160, 0.12) 30%,
              transparent 70%
            )
          `,
          filter: "blur(80px)",
        }}
      />

      {/* Layer 2: Gold Accent — Secondary brand color */}
      <div
        className="aurora-layer-2 absolute aurora-pulse"
        style={{
          top: "-10%",
          right: "-30%",
          width: "120%",
          height: "120%",
          background: `
            radial-gradient(
              ellipse 70% 50% at 70% 60%,
              rgba(201, 168, 76, 0.10) 0%,
              rgba(201, 168, 76, 0.05) 40%,
              transparent 70%
            )
          `,
          filter: "blur(100px)",
        }}
      />

      {/* Layer 3: Soft Purple Glow — Depth layer */}
      <div
        className="aurora-layer-3 absolute"
        style={{
          bottom: "-30%",
          left: "10%",
          width: "100%",
          height: "100%",
          background: `
            radial-gradient(
              ellipse 60% 40% at 50% 80%,
              rgba(102, 54, 157, 0.12) 0%,
              rgba(139, 92, 214, 0.06) 50%,
              transparent 80%
            )
          `,
          filter: "blur(60px)",
        }}
      />

      {/* Subtle warm glow at center */}
      <div
        className="absolute"
        style={{
          top: "30%",
          left: "50%",
          transform: "translateX(-50%)",
          width: "600px",
          height: "400px",
          background: `
            radial-gradient(
              ellipse 50% 40% at 50% 50%,
              rgba(201, 168, 76, 0.04) 0%,
              transparent 70%
            )
          `,
          filter: "blur(40px)",
        }}
      />
    </div>
  );
}
